// extracted by mini-css-extract-plugin
export default {"pointsInfoContainer":"ApplicationGrid_pointsInfoContainer__oYvoC","button":"ApplicationGrid_button__BKyt-","buttonLink":"ApplicationGrid_buttonLink__r9zOk"};